var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserClicks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9261 15L13.9919 14.2425C14.0353 13.7522 13.9032 13.2624 13.6202 12.8648C13.3372 12.4672 12.9227 12.189 12.4543 12.0822L10.0522 11.534V8.26582C10.0522 7.93011 9.92226 7.60814 9.69091 7.37075C9.45957 7.13336 9.14579 7 8.81862 7C8.49144 7 8.17767 7.13336 7.94632 7.37075C7.71497 7.60814 7.585 7.93011 7.585 8.26582V13.8692L6.61324 13.1212C6.41901 12.9719 6.17884 12.8995 5.93678 12.9172C5.69472 12.935 5.46701 13.0416 5.29541 13.2177C5.12382 13.3938 5.01984 13.6275 5.00256 13.8758C4.98528 14.1242 5.05585 14.3707 5.20133 14.57L5.51319 14.9966",
    stroke: "#1F5850",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9H13C15.2091 9 17 7.20914 17 5V5C17 2.79086 15.2091 1 13 1H5C2.79086 1 1 2.79086 1 5V5C1 7.20914 2.79086 9 5 9H5.75",
    stroke: "#1F5850",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserClicks);
export default __webpack_public_path__ + "static/media/user-clicks.8129ea4e747b1dca6f69a58ea54385ad.svg";
export { ForwardRef as ReactComponent };